class FeedbackDataStorage {
    avalanche = process.env.PROFILE_DATA_TARGET === "avalanche";
    avalancheProvider;
    constructor(avalancheProvider) {
        this.avalancheProvider = avalancheProvider;
    }
    async set(key, toStore) {
        if (this.avalanche) {
            this.avalancheProvider.setFeedbackData(key, toStore);
        }
    }
    async get() {
        if (this.avalanche) {
            return this.avalancheProvider.getAllFeedback();
        }
        return undefined;
    }
    async hasData() {
        if (this.avalanche) {
            const feedbacks = await this.avalancheProvider.getAllFeedback();
            return !!feedbacks;
        }
        return false;
    }
    async delete() {
        if (this.avalanche) {
            this.avalancheProvider.deleteAllFeedback();
        }
    }
}
export default FeedbackDataStorage;
